import { render, staticRenderFns } from "./EditarAlertaModal.vue?vue&type=template&id=57fd0b60&"
import script from "./EditarAlertaModal.vue?vue&type=script&lang=ts&"
export * from "./EditarAlertaModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('57fd0b60', component.options)
    } else {
      api.reload('57fd0b60', component.options)
    }
    module.hot.accept("./EditarAlertaModal.vue?vue&type=template&id=57fd0b60&", function () {
      api.rerender('57fd0b60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Alertas/EditarAlertaModal.vue"
export default component.exports